import React, { useState, useEffect, useContext, lazy, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Navigation from "../../../components/navigation";
import SecondScreen from "../../SecondScreen";
import { Text, TextEdit, GetQrLink } from "../../../redux/requests/text";
import { linkStep, navigationStep } from "../../../redux/slices/navigation";
import { preloaderToggle } from "../../../redux/slices/preloader";
import StepCustomize from "../../../components/stepCustomize";
import { Context } from "../../../components/saveFile/saveFile";
import QrTitleField from "../../../components/input/qrTitleField";
import { saveValueText } from "../../../redux/slices/saveValue";
import axios from "axios";
import { isNoEditRoute } from "../../../hooks/helpers";
import { setCategory } from "../../../redux/slices/selectCategories";
import Form from "react-bootstrap/Form";
import { SelectCategory } from "../../../components";
import PopoverBtn from "../../../components/popoverBtn";
import { Col, Row, Spinner } from "react-bootstrap";
import s from "./TextPage.scss?module";
import classNames from "classnames";
import useTypeDecription from "../../../hooks/useTypeDecription";
import useGetDataError from "../../../hooks/useGetDataError";
import useCurrentLocation from "../../../hooks/useCurrentLocation";
const CKEditor = lazy(() =>
  import("@ckeditor/ckeditor5-react").then((module) => ({
    default: module.CKEditor,
  }))
);

const MAX_LENGTH = 100000;

export default function TextPage() {
  const { lang, getQrLinkSliceId, categoryChange, valueText } = useSelector(
    (state) => ({
      lang: state.changeLang.language.stepTwo.text,
      getQrLinkSliceId: state.getQrLinkSlice.id,
      categoryChange: state.categories.categoryChange,
      valueText: state.saveValue.valueText,
    })
  );
  const { id } = useParams();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { content, getContent } = useTypeDecription();
  const { checkErrorStatus } = useGetDataError();
  const { adminEntryLocation } = useCurrentLocation();

  const { saveText, setSaveText } = useContext(Context);
  const [qrTitle, setQrTitle] = useState(valueText[0]);
  const [textValue, setTextValue] = useState("");
  const [empty, setEmpty] = useState(false);
  const [textEditor, setTextEditor] = useState(null);
  const [isShowCategoryField, setIsShowCategoryField] = useState(false);

  useEffect(() => {
    getContent("text");
  }, []);

  useEffect(() => {
    import("ckeditor5-custom-build/build/ckeditor")
      .then((module) => {
        setTextEditor(() => module.default);
      })
      .catch((error) => {
        console.error("Failed to load CKEditor editor:", error);
      });
  }, []);

  useEffect(() => {
    if (id) {
      setIsShowCategoryField(true);
      axios
        .get(`/text/get/${id}`)
        .then(({ data }) => {
          data[0]?.text && setTextValue(data[0].text);
          setQrTitle(data.qrTitle);
          dispatch(setCategory(data.adsCategories));
        })
        .catch((err) => {
          checkErrorStatus(err.response.status);
        });
    }
  }, [id]);

  useEffect(() => {
    if (!!textValue) {
      dispatch(linkStep(true));
    } else {
      dispatch(linkStep(false));
    }
  }, [textValue]);
  function step() {
    if (!!textValue && !getQrLinkSliceId && !id) {
      setEmpty(false);
      dispatch(GetQrLink(() => Text([textValue, categoryChange, qrTitle])));
      setSaveText(textValue);
      dispatch(saveValueText([qrTitle]));
      dispatch(preloaderToggle(true));
      dispatch(navigationStep(3));
      navigate("/qr");
    } else {
      setEmpty(true);
    }

    if (!!saveText && saveText === textValue) {
      navigate("/qr");
      setTimeout(() => {
        dispatch(preloaderToggle(false));
      }, 0);
    }
    if ((getQrLinkSliceId && saveText !== textValue) || id) {
      dispatch(
        GetQrLink(() =>
          TextEdit([getQrLinkSliceId || id, textValue, categoryChange, qrTitle])
        )
      ).then(() => {
        if (!isNoEditRoute) {
          window.location.href = adminEntryLocation;
        }
      });

      if (isNoEditRoute) {
        setSaveText(textValue);
        dispatch(saveValueText([qrTitle]));
        dispatch(navigationStep(3));
        navigate("/qr");
      } else {
        dispatch(preloaderToggle(true));
      }
    }
  }

  useEffect(() => {
    if (saveText) {
      setTextValue(saveText);
    }
  }, [saveText]);

  const Loader = () => {
    return (
      <div className="text-center">
        <Spinner
          animation="border"
          role="status"
          style={{ marginTop: 90, marginBottom: 90 }}
        />
      </div>
    );
  };

  return (
    <>
      <Navigation />
      <SecondScreen>
        <Form className="col-12 col-lg-6 mx-auto">
          <Suspense fallback={<Loader />}>
            {textEditor ? (
              <>
                <Row className="position-relative flex-nowrap mb-3">
                  <Col
                    xs={12}
                    md={11}
                    className={classNames(s.ckEditorContainer)}
                  >
                    <CKEditor
                      editor={textEditor}
                      data={textValue || ""}
                      onReady={(editor) => {
                        // You can store the "editor" and use when it is needed.
                        // console.log( 'Editor is ready to use!', editor );
                      }}
                      onChange={(event, editor) => {
                        setTextValue(editor.getData());
                      }}
                      onBlur={(event, editor) => {
                        // console.log( 'Blur.', editor );
                      }}
                      onFocus={() => {
                        setIsShowCategoryField(true);
                      }}
                      config={{ placeholder: lang[20] }}
                    />
                    <div className="d-flex justify-content-end text-gray">
                      <small>{`${textValue.length}/${MAX_LENGTH}`}</small>
                    </div>
                    {empty && textValue?.length === 0 && (
                      <Form.Text className="text-danger">{lang[0]}</Form.Text>
                    )}
                    {textValue.length > MAX_LENGTH && (
                      <Form.Text className="text-danger">{lang[22]}</Form.Text>
                    )}
                  </Col>
                  <div className="position-absolute top-50 end-0 translate-middle-y w-auto me-3">
                    <PopoverBtn text={lang[21]} />
                  </div>
                </Row>
              </>
            ) : (
              <Loader />
            )}
          </Suspense>

          <QrTitleField
            value={qrTitle}
            onChange={(e) => setQrTitle(e.target.value)}
          />
        </Form>

        {isShowCategoryField && <SelectCategory />}
        <StepCustomize
          emulate={step}
          disabled={!textValue?.length || textValue.length > MAX_LENGTH}
        />
      </SecondScreen>

      {isNoEditRoute && content}
    </>
  );
}
